module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/provider/list.component.css
// module id = ./src/app/views/provider/list.component.css
// module chunks = main